import React, { useState } from "react";
import { validateEmail } from "../../util/validate";
import useTranslation from "next-translate/useTranslation";
import Input from "../../components/ui/input-form";
import styles from "./styles/Settings.module.css";
import { FaCheck } from "react-icons/fa";
import { setLoadingBar } from "../../redux/siteData";
import { api } from "../../services/api";
import { errorCodes } from "@chesshotel/constants";
import { Button } from "@/components/ui/button";

export default function Email() {
  const { t } = useTranslation("common");
  const { t: settingsT } = useTranslation("auth");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(null);
  const [emailUpdated, setEmailUpdated] = useState(null);

  async function updateEmail() {
    setEmailError(await validateEmail(email));
    if (!emailError) {
      setLoadingBar(true);
      api
        .post("/users/email", { email })
        .then(() => {
          setEmailUpdated(true);
        })
        .catch(() => {
          setEmailError(errorCodes.ERROR_EMAIL_NOT_AVAILABLE);
        })
        .then(() => {
          setLoadingBar(false);
        });
    }
  }

  return (
    <div className={styles.body}>
      <div className={styles.title}>
        {settingsT("Update email")}{" "}
        {emailUpdated && (
          <div className={styles.doneCheck}>
            <FaCheck />
          </div>
        )}
      </div>
      <div className={styles.form}>
        <Input
          className={styles.margin}
          onChange={(e) => setEmail(e.target.value)}
          label={t("Email")}
          type="text"
          value={email}
          errorCode={emailError}
        />
        <Button variant="default" size="wide" onClick={() => updateEmail()}>
          {t("Save")}
        </Button>
      </div>
    </div>
  );
}
